<template>
<v-container>
    <v-row>
      <v-col cols="6">
        <v-text-field
          ref="input"
          label="Ragione Sociale"
          name="ragioneSociale"
          type="text"
          filled
          v-model="registrationInfo.RagioneSociale"
        ></v-text-field>
      </v-col>

      <v-col cols="6">
        <v-text-field
          ref="input"
          label="Partita IVA"
          name="partitaIVA "
          type="text"
          filled
          v-model="registrationInfo.PartitaIVA"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          ref="input"
          label="Indirizzo"
          name="indirizzo"
          type="text"
          filled
          v-model="registrationInfo.Indirizzo"
        ></v-text-field>
      </v-col>
 <v-col cols="2">
        <v-text-field
          ref="input"
          label="Città"
          name="city"
          type="text"
          filled
          v-model="registrationInfo.City"
        ></v-text-field>
      </v-col>
<v-col cols="2">
        <v-text-field
          label="Provincia"
          name="province"
          type="text"
          filled
          v-model="registrationInfo.Province"
        ></v-text-field>
      </v-col>
      
      <v-col cols="2">
        <v-text-field
          ref="input"
          label="CAP"
          name="cap"
          type="number"
          filled
          v-model="registrationInfo.CAP"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          label="Telefono"
          name="telefono "
          type="number"
          filled
          v-model="registrationInfo.Telefono"
        ></v-text-field>
      </v-col>

     
      
      
    </v-row>
  </v-container>
</template>
<script>


export default {
   props:["registrationInfo"],
  data:() => ({
    error: null,
  })
  
};
</script>